import {GTS_FAILURE, GTS_SUCCESS} from './constants'
export async function getTemplate(data, dispatch) {
  try {
    dispatch({type: GTS_SUCCESS, payload: data})
  } catch (e) {
    console.log(`Get Templates Failed: ${data.id}`)
    dispatch({type: GTS_FAILURE, payload: e})
  }
}
